<template>
    <div class="editor-box padding-box">
        <el-scrollbar>
            <div>
                <UserSimpleInfo :obj="obj" />

<!--                <div
                    v-if="userInfoRef.addinfo6 == -1"
                    style="margin-top: 20px; margin-bottom: 10px"
                >
                    <el-button
                        type="primary"
                        plain
                        @click="clickEditBtn"
                        size="small"
                        :color="'#32c5d2'"
                        class="icon-button"
                    >
                        <font-awesome-icon icon="fa-solid fa-pen-to-square" />
                        &nbsp;
                        <span tkey="編輯信息">{{i18n.tkey("lang_edit_information")}}</span>
                    </el-button>
                </div>-->

<!--                <div style="margin-bottom: 10px">-->
<!--                    <el-button-->
<!--                        type="warning"-->
<!--                        plain-->
<!--                        @click="clickViewBtn('myQuotation')"-->
<!--                        size="small"-->
<!--                        class="icon-button"-->
<!--                    >-->
<!--                        <font-awesome-icon icon="fa-solid fa-file-invoice-dollar" />-->
<!--                        &nbsp;-->
<!--                        <span tkey="我的報價單">{{i18n.tkey("lang_my_quotation")}}</span>-->
<!--                    </el-button>-->
<!--                </div>-->

                <div>
                    <el-button
                        type="warning"
                        plain
                        @click="clickViewBtn('setting')"
                        size="small"
                        class="icon-button"
                    >
                        <font-awesome-icon icon="fa-solid fa-gear" />
                        &nbsp;
                        <span tkey="設置">{{i18n.tkey("lang_setting")}}</span>
                    </el-button>
                </div>
            </div>
        </el-scrollbar>

        <el-dialog
            v-model="editVisible"
            :title="i18n.tkey('lang_edit_staff')"
            :width="myUtil.isMobile() ? '90%' : '600px'"
            align-center
            destroy-on-close
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <companyStaffEditor
                :editLogin="obj.login"
                @save-complete="saveCallback"
            />
        </el-dialog>

    </div>
</template>

<script setup>

//导入图标
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPenToSquare, faFileInvoiceDollar, faGear } from '@fortawesome/free-solid-svg-icons'
import {inject, toRef, ref, provide, onBeforeMount, computed, watch} from "vue";
import {useUserinfo} from "@/stores/userinfo";
import myUtil from "@/util/util";
import CompanyStaffEditor from "@/components/shopopee/company/companyStaffEditor.vue";
import UserSimpleInfo from "@/components/shopopee/user/userSimpleInfo.vue";

library.add(faPenToSquare, faFileInvoiceDollar, faGear)

const props = defineProps(["obj","visible"])
const emits = defineEmits(["clickViewBtn", "save-complete","changeEditUser"])

const i18n = inject("i18n")
const userInfoRef = toRef(useUserinfo())
const editVisible = ref(false)

watch(() => props.visible, (newValue, oldValue) => {
  if(props.visible){
    editVisible.value=props.visible
  }
})

watch(() => editVisible.value, (newValue, oldValue) => {
  if(!editVisible.value){
    emits("changeEditUser", newValue)
  }
})
function clickEditBtn(){
    editVisible.value = true
}

function clickViewBtn(name){
    emits("clickViewBtn", name)
}

function saveCallback(){
    emits("save-complete")
}

function getCurrCard(){
    return props.obj
}


provide('myCardViewFunc', {
    getCurrCard,
  updateAddinfo1,
})
function updateAddinfo1(addinfo1){
  console.log(addinfo1)
}

</script>

<style scoped>

.editor-box {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
    text-align: left;
}

.padding-box {
    padding: 10px;
    box-sizing: border-box;
}

.main-icon {
    color: #409EFF;
}

.main-text {
    font-size: 16px;
}

.normal-text {
    font-size: 16px;
}

.text-box {
    line-height: 1.5;
}





</style>